// This is similar to "map-config.js" with basic settings (colors, info., etc)

/**
 * ARI Colors:
 *
 * For counties:
 * upColor: #3eb2b2
 * overColor: #0eea50
 * downColor: #3f51b5
 *
 * For circuits:
 *
 *
 *
 * For planning grants:
 *
 *
 */
const usiljsconfig = {
  usiljs1: {
    hover: "ADAMS", //info of the popup
    url: "", //link to any webpage
    target: "vue", // use "new_window", "same_window", "modal", or "none"
    upColor: "#3eb2b2", //default color
    overColor: "#0eea50", //highlight color
    downColor: "#cae9af", //clicking color
    active: true,
    slug: "adams-county",
    name: "Adams",
    circuit: null,
  },
  usiljs2: {
    hover: "ALEXANDER",
    url: "",
    target: "vue",
    upColor: "#FFFFFF",
    overColor: "#0eea50",
    downColor: "#cae9af",
    active: false,
  },
  usiljs3: {
    hover: "BOND",
    url: "",
    target: "vue",
    upColor: "#FFFFFF",
    overColor: "#0eea50",
    downColor: "#cae9af",
    active: false,
  },
  usiljs4: {
    hover: "BOONE",
    url: "",
    target: "vue",
    upColor: "#3eb2b2",
    overColor: "#0eea50",
    downColor: "#cae9af",
    active: true,
    slug: "boone-county",
  },
  usiljs5: {
    hover: "BROWN",
    url: "",
    target: "vue",
    upColor: "#FFFFFF",
    overColor: "#0eea50",
    downColor: "#cae9af",
    active: false,
  },
  usiljs6: {
    hover: "BUREAU",
    url: "",
    target: "vue",
    upColor: "#FFFFFF",
    overColor: "#0eea50",
    downColor: "#cae9af",
    active: false,
  },
  usiljs7: {
    hover: "CALHOUN",
    url: "",
    target: "vue",
    upColor: "#FFFFFF",
    overColor: "#0eea50",
    downColor: "#cae9af",
    active: false,
  },
  usiljs8: {
    hover: "CARROLL",
    url: "",
    target: "vue",
    upColor: "#FFFFFF",
    overColor: "#0eea50",
    downColor: "#cae9af",
    active: false,
  },
  usiljs9: {
    hover: "CASS",
    url: "",
    target: "vue",
    upColor: "#FFFFFF",
    overColor: "#0eea50",
    downColor: "#cae9af",
    active: false,
  },
  usiljs10: {
    hover: "CHAMPAIGN",
    url: "",
    target: "vue",
    upColor: "#3eb2b2",
    overColor: "#0eea50",
    downColor: "#cae9af",
    active: true,
    name: "Champaign",
    slug: "champaign-county",
  },
  usiljs11: {
    hover: "CHRISTIAN",
    url: "",
    target: "vue",
    upColor: "#3eb2b2",
    overColor: "#0eea50",
    downColor: "#cae9af",
    active: true,
    name: "Christian",
    slug: "fourth-judicial-circuit",
  },
  usiljs12: {
    hover: "CLARK",
    url: "",
    target: "vue",
    upColor: "#FFFFFF",
    overColor: "#0eea50",
    downColor: "#cae9af",
    active: false,
  },
  usiljs13: {
    hover: "CLAY",
    url: "",
    target: "vue",
    upColor: "#ffffff",
    overColor: "#0eea50",
    downColor: "#cae9af",
    active: false,
    name: "Clay",
    slug: "fourth-judicial-circuit",
  },
  usiljs14: {
    hover: "CLINTON",
    url: "",
    target: "vue",
    upColor: "#3eb2b2",
    overColor: "#0eea50",
    downColor: "#cae9af",
    active: true,
    name: "Clinton",
    slug: "fourth-judicial-circuit",
  },
  usiljs15: {
    hover: "COLES",
    url: "",
    target: "vue",
    upColor: "#FFFFFF",
    overColor: "#0eea50",
    downColor: "#cae9af",
    active: false,
  },
  usiljs16: {
    hover: "COOK",
    url: "",
    target: "vue",
    upColor: "#3eb2b2",
    overColor: "#0eea50",
    downColor: "#cae9af",
    active: true,
    name: "Cook",
    slug: "cook-county",
  },
  usiljs17: {
    hover: "CRAWFORD",
    url: "",
    target: "vue",
    upColor: "#3eb2b2",
    overColor: "#0eea50",
    downColor: "#cae9af",
    active: true,
    name: "Crawford",
    slug: "second-judicial-circuit",
  },
  usiljs18: {
    hover: "CUMBERLAND",
    url: "",
    target: "vue",
    upColor: "#FFFFFF",
    overColor: "#0eea50",
    downColor: "#cae9af",
    active: false,
  },
  usiljs19: {
    hover: "DEKALB",
    url: "",
    target: "vue",
    upColor: "#3eb2b2",
    overColor: "#0eea50",
    downColor: "#cae9af",
    active: true,
    name: "DeKalb",
    circuit: null,
    slug: "dekalb-county",
  },
  usiljs20: {
    hover: "DEWITT",
    url: "",
    target: "vue",
    upColor: "#FFFFFF",
    overColor: "#0eea50",
    downColor: "#cae9af",
    active: false,
  },
  usiljs21: {
    hover: "DOUGLAS",
    url: "",
    target: "vue",
    upColor: "#FFFFFF",
    overColor: "#0eea50",
    downColor: "#cae9af",
    active: false,
  },
  usiljs22: {
    hover: "DUPAGE",
    url: "",
    target: "vue",
    upColor: "#3eb2b2",
    overColor: "#0eea50",
    downColor: "#cae9af",
    active: true,
    name: "DuPage",
    circuit: null,
    slug: "dupage-county",
  },
  usiljs23: {
    hover: "EDGAR",
    url: "",
    target: "vue",
    upColor: "#FFFFFF",
    overColor: "#0eea50",
    downColor: "#cae9af",
    active: false,
  },
  usiljs24: {
    hover: "EDWARDS",
    url: "",
    target: "vue",
    upColor: "#3eb2b2",
    overColor: "#0eea50",
    downColor: "#cae9af",
    active: true,
    name: "Edwards",
    slug: "second-judicial-circuit",
  },
  usiljs25: {
    hover: "EFFINGHAM",
    url: "",
    target: "vue",
    upColor: "#3eb2b2",
    overColor: "#0eea50",
    downColor: "#cae9af",
    active: true,
    name: "Effingham",
    slug: "fourth-judicial-circuit",
  },
  usiljs26: {
    hover: "FAYETTE",
    url: "",
    target: "vue",
    upColor: "#3eb2b2",
    overColor: "#0eea50",
    downColor: "#cae9af",
    active: true,
    name: "Fayette",
    slug: "fourth-judicial-circuit",
  },
  usiljs27: {
    hover: "FORD",
    url: "",
    target: "vue",
    upColor: "#FFFFFF",
    overColor: "#0eea50",
    downColor: "#cae9af",
    active: false,
  },
  usiljs28: {
    hover: "FRANKLIN",
    url: "",
    target: "vue",
    upColor: "#3eb2b2",
    overColor: "#0eea50",
    downColor: "#cae9af",
    active: true,
    slug: "second-judicial-circuit",
  },
  usiljs29: {
    hover: "FULTON",
    url: "",
    target: "vue",
    upColor: "#3eb2b2",
    overColor: "#0eea50",
    downColor: "#cae9af",
    active: true,
    name: "Fulton",
    slug: "ninth-judicial-circuit",
  },
  usiljs30: {
    hover: "GALLATIN",
    url: "",
    target: "vue",
    upColor: "#3eb2b2",
    overColor: "#0eea50",
    downColor: "#cae9af",
    active: true,
    name: "Gallatin",
    slug: "second-judicial-circuit",
  },
  usiljs31: {
    hover: "GREENE",
    url: "",
    target: "vue",
    upColor: "#FFFFFF",
    overColor: "#0eea50",
    downColor: "#cae9af",
    active: false,
  },
  usiljs32: {
    hover: "GRUNDY",
    url: "",
    target: "vue",
    upColor: "#3eb2b2",
    overColor: "#0eea50",
    downColor: "#cae9af",
    active: true,
    name: "Grundy",
    slug: "grundy-county",
  },
  usiljs33: {
    hover: "HAMILTON",
    url: "",
    target: "vue",
    upColor: "#3eb2b2",
    overColor: "#0eea50",
    downColor: "#cae9af",
    active: true,
    name: "Hamilton",
    slug: "second-judicial-circuit",
  },
  usiljs34: {
    hover: "HANCOCK",
    url: "",
    target: "vue",
    upColor: "#3eb2b2",
    overColor: "#0eea50",
    downColor: "#cae9af",
    active: true,
    name: "Hancock",
    slug: "ninth-judicial-circuit",
  },
  usiljs35: {
    hover: "HARDIN",
    url: "",
    target: "vue",
    upColor: "#3eb2b2",
    overColor: "#0eea50",
    downColor: "#cae9af",
    active: true,
    name: "Hardin",
    slug: "second-judicial-circuit",
  },
  usiljs36: {
    hover: "HENDERSON",
    url: "",
    target: "vue",
    upColor: "#3eb2b2",
    overColor: "#0eea50",
    downColor: "#cae9af",
    active: true,
    name: "Henderson",
    slug: "ninth-judicial-circuit",
  },
  usiljs37: {
    hover: "HENRY",
    url: "",
    target: "vue",
    upColor: "#FFFFFF",
    overColor: "#0eea50",
    downColor: "#cae9af",
    active: false,
  },
  usiljs38: {
    hover: "IROQUOIS",
    url: "",
    target: "vue",
    upColor: "#FFFFFF",
    overColor: "#0eea50",
    downColor: "#cae9af",
    active: false,
  },
  usiljs39: {
    hover: "JACKSON",
    url: "",
    target: "vue",
    upColor: "#FFFFFF",
    overColor: "#0eea50",
    downColor: "#cae9af",
    active: false,
  },
  usiljs40: {
    hover: "JASPER",
    url: "",
    target: "vue",
    upColor: "#ffffff",
    overColor: "#0eea50",
    downColor: "#cae9af",
    active: false,
  },
  usiljs41: {
    hover: "JEFFERSON",
    url: "",
    target: "vue",
    upColor: "#3eb2b2",
    overColor: "#0eea50",
    downColor: "#cae9af",
    active: true,
    name: "Jefferson",
    slug: "second-judicial-circuit",
  },
  usiljs42: {
    hover: "JERSEY",
    url: "",
    target: "vue",
    upColor: "#3eb2b2",
    overColor: "#0eea50",
    downColor: "#cae9af",
    active: true,
    name: "Jersey",
    slug: "jersey-county",
  },
  usiljs43: {
    hover: "JO DAVIESS",
    url: "",
    target: "vue",
    upColor: "#FFFFFF",
    overColor: "#0eea50",
    downColor: "#cae9af",
    active: false,
  },
  usiljs44: {
    hover: "JOHNSON",
    url: "",
    target: "vue",
    upColor: "#FFFFFF",
    overColor: "#0eea50",
    downColor: "#cae9af",
    active: false,
  },
  usiljs45: {
    hover: "KANE",
    url: "",
    target: "vue",
    upColor: "#FFFFFF",
    overColor: "#0eea50",
    downColor: "#cae9af",
    active: false,
  },
  usiljs46: {
    hover: "KANKAKEE",
    url: "",
    target: "vue",
    upColor: "#FFFFFF",
    overColor: "#0eea50",
    downColor: "#cae9af",
    active: false,
  },
  usiljs47: {
    hover: "KENDALL",
    url: "",
    target: "vue",
    upColor: "#3eb2b2",
    overColor: "#0eea50",
    downColor: "#cae9af",
    active: true,
    name: "Kendall",
    slug: "kendall-county",
  },
  usiljs48: {
    hover: "KNOX",
    url: "",
    target: "vue",
    upColor: "#3eb2b2",
    overColor: "#0eea50",
    downColor: "#cae9af",
    active: true,
    name: "Knox",
    slug: "ninth-judicial-circuit",
  },
  usiljs49: {
    hover: "LAKE",
    url: "",
    target: "vue",
    upColor: "#3eb2b2",
    overColor: "#0eea50",
    downColor: "#cae9af",
    active: true,
    name: "Lake",
    slug: "lake-county",
  },
  usiljs50: {
    hover: "LASALLE",
    url: "",
    target: "vue",
    upColor: "#3eb2b2",
    overColor: "#0eea50",
    downColor: "#cae9af",
    active: true,
    name: "LaSalle",
    slug: "lasalle-county",
  },
  usiljs51: {
    hover: "LAWRENCE",
    url: "",
    target: "vue",
    upColor: "#3eb2b2",
    overColor: "#0eea50",
    downColor: "#cae9af",
    active: true,
    name: "Lawrence",
    slug: "second-judicial-circuit",
  },
  usiljs52: {
    hover: "LEE",
    url: "",
    target: "vue",
    upColor: "#FFFFFF",
    overColor: "#0eea50",
    downColor: "#cae9af",
    active: false,
  },
  usiljs53: {
    hover: "LIVINGSTON",
    url: "",
    target: "vue",
    upColor: "#FFFFFF",
    overColor: "#0eea50",
    downColor: "#cae9af",
    active: false,
  },
  usiljs54: {
    hover: "LOGAN",
    url: "",
    target: "vue",
    upColor: "#FFFFFF",
    overColor: "#0eea50",
    downColor: "#cae9af",
    active: false,
  },
  usiljs55: {
    hover: "MACON",
    url: "",
    target: "vue",
    upColor: "#3eb2b2",
    overColor: "#0eea50",
    downColor: "#cae9af",
    active: true,
    name: "Macon",
    slug: "macon-county",
  },
  usiljs56: {
    hover: "MACOUPIN",
    url: "",
    target: "vue",
    upColor: "#FFFFFF",
    overColor: "#0eea50",
    downColor: "#cae9af",
    active: false,
  },
  usiljs57: {
    hover: "MADISON",
    url: "",
    target: "vue",
    upColor: "#3eb2b2",
    overColor: "#0eea50",
    downColor: "#cae9af",
    active: true,
    name: "Madison",
    slug: "madison-county",
  },
  usiljs58: {
    hover: "MARION",
    url: "",
    target: "vue",
    upColor: "#FFFFFF",
    overColor: "#0eea50",
    downColor: "#cae9af",
    active: false,
  },
  usiljs59: {
    hover: "MARSHALL",
    url: "",
    target: "vue",
    upColor: "#FFFFFF",
    overColor: "#0eea50",
    downColor: "#cae9af",
    active: false,
  },
  usiljs60: {
    hover: "MASON",
    url: "",
    target: "vue",
    upColor: "#FFFFFF",
    overColor: "#0eea50",
    downColor: "#cae9af",
    active: false,
  },
  usiljs61: {
    hover: "MASSAC",
    url: "",
    target: "vue",
    upColor: "#FFFFFF",
    overColor: "#0eea50",
    downColor: "#cae9af",
    active: false,
  },
  usiljs62: {
    hover: "MCDONOUGH",
    url: "",
    target: "vue",
    upColor: "#3eb2b2",
    overColor: "#0eea50",
    downColor: "#cae9af",
    active: true,
    name: "McDonough",
    slug: "ninth-judicial-circuit",
  },
  usiljs63: {
    hover: "MCHENRY",
    url: "",
    target: "vue",
    upColor: "#FFFFFF",
    overColor: "#0eea50",
    downColor: "#cae9af",
    active: false,
  },
  usiljs64: {
    hover: "MCLEAN",
    url: "",
    target: "vue",
    upColor: "#3eb2b2",
    overColor: "#0eea50",
    downColor: "#cae9af",
    active: true,
    name: "McClean",
    slug: "mclean-county",
  },
  usiljs65: {
    hover: "MENARD",
    url: "",
    target: "vue",
    upColor: "#FFFFFF",
    overColor: "#0eea50",
    downColor: "#cae9af",
    active: false,
  },
  usiljs66: {
    hover: "MERCER",
    url: "",
    target: "vue",
    upColor: "#FFFFFF",
    overColor: "#0eea50",
    downColor: "#cae9af",
    active: false,
  },
  usiljs67: {
    hover: "MONROE",
    url: "",
    target: "vue",
    upColor: "#3eb2b2",
    overColor: "#0eea50",
    downColor: "#cae9af",
    active: true,
    name: "Monroe",
    slug: "washington-perry-counties",
  },
  usiljs68: {
    hover: "MONTGOMERY",
    url: "",
    target: "vue",
    upColor: "#3eb2b2",
    overColor: "#0eea50",
    downColor: "#cae9af",
    active: true,
    name: "Montgomery",
    slug: "montgomery-county",
  },
  usiljs69: {
    hover: "MORGAN",
    url: "",
    target: "vue",
    upColor: "#FFFFFF",
    overColor: "#0eea50",
    downColor: "#cae9af",
    active: false,
  },
  usiljs70: {
    hover: "MOULTRIE",
    url: "",
    target: "vue",
    upColor: "#FFFFFF",
    overColor: "#0eea50",
    downColor: "#cae9af",
    active: false,
  },
  usiljs71: {
    hover: "OGLE",
    url: "",
    target: "vue",
    upColor: "#FFFFFF",
    overColor: "#0eea50",
    downColor: "#cae9af",
    active: false,
  },
  usiljs72: {
    hover: "PEORIA",
    url: "",
    target: "vue",
    upColor: "#3eb2b2",
    overColor: "#0eea50",
    downColor: "#cae9af",
    active: true,
    name: "Peoria",
    slug: "peoria-county",
  },
  usiljs73: {
    hover: "PERRY",
    url: "",
    target: "vue",
    upColor: "#3eb2b2",
    overColor: "#0eea50",
    downColor: "#cae9af",
    active: true,
    name: "Perry",
    slug: "washington-perry-counties",
  },
  usiljs74: {
    hover: "PIATT",
    url: "",
    target: "vue",
    upColor: "#FFFFFF",
    overColor: "#0eea50",
    downColor: "#cae9af",
    active: false,
  },
  usiljs75: {
    hover: "PIKE",
    url: "",
    target: "vue",
    upColor: "#FFFFFF",
    overColor: "#0eea50",
    downColor: "#cae9af",
    active: false,
  },
  usiljs76: {
    hover: "POPE",
    url: "",
    target: "vue",
    upColor: "#FFFFFF",
    overColor: "#0eea50",
    downColor: "#cae9af",
    active: false,
  },
  usiljs77: {
    hover: "PULASKI",
    url: "",
    target: "vue",
    upColor: "#FFFFFF",
    overColor: "#0eea50",
    downColor: "#cae9af",
    active: false,
  },
  usiljs78: {
    hover: "PUTNAM",
    url: "",
    target: "vue",
    upColor: "#FFFFFF",
    overColor: "#0eea50",
    downColor: "#cae9af",
    active: false,
  },
  usiljs79: {
    hover: "RANDOLPH",
    url: "",
    target: "vue",
    upColor: "#FFFFFF",
    overColor: "#0eea50",
    downColor: "#cae9af",
    active: false,
  },
  usiljs80: {
    hover: "RICHLAND",
    url: "",
    target: "vue",
    upColor: "#3eb2b2",
    overColor: "#0eea50",
    downColor: "#cae9af",
    active: true,
    name: "Richland",
    slug: "second-judicial-circuit",
  },
  usiljs81: {
    hover: "ROCK ISLAND",
    url: "",
    target: "vue",
    upColor: "#FFFFFF",
    overColor: "#0eea50",
    downColor: "#cae9af",
    active: false,
  },
  usiljs82: {
    hover: "SALINE",
    url: "",
    target: "vue",
    upColor: "#FFFFFF",
    overColor: "#0eea50",
    downColor: "#cae9af",
    active: false,
  },
  usiljs83: {
    hover: "SANGAMON",
    url: "",
    target: "vue",
    upColor: "#3eb2b2",
    overColor: "#0eea50",
    downColor: "#cae9af",
    active: true,
    name: "Sangamon",
    slug: "sangamon-county",
  },
  usiljs84: {
    hover: "SCHUYLER",
    url: "",
    target: "vue",
    upColor: "#FFFFFF",
    overColor: "#0eea50",
    downColor: "#cae9af",
    active: false,
  },
  usiljs85: {
    hover: "SCOTT",
    url: "",
    target: "vue",
    upColor: "#FFFFFF",
    overColor: "#0eea50",
    downColor: "#cae9af",
    active: false,
  },
  usiljs86: {
    hover: "SHELBY",
    url: "",
    target: "vue",
    upColor: "#FFFFFF",
    overColor: "#0eea50",
    downColor: "#cae9af",
    active: false,
  },
  usiljs87: {
    hover: "ST. CLAIR",
    url: "",
    target: "vue",
    upColor: "#3eb2b2",
    overColor: "#0eea50",
    downColor: "#cae9af",
    active: true,
    name: "St. Clair",
    slug: "twentieth-judicial-circuit",
  },
  usiljs88: {
    hover: "STARK",
    url: "",
    target: "vue",
    upColor: "#FFFFFF",
    overColor: "#0eea50",
    downColor: "#cae9af",
    active: false,
  },
  usiljs89: {
    hover: "STEPHENSON",
    url: "",
    target: "vue",
    upColor: "#FFFFFF",
    overColor: "#0eea50",
    downColor: "#cae9af",
    active: false,
  },
  usiljs90: {
    hover: "TAZEWELL",
    url: "",
    target: "vue",
    upColor: "#FFFFFF",
    overColor: "#0eea50",
    downColor: "#cae9af",
    active: false,
  },
  usiljs91: {
    hover: "UNION",
    url: "",
    target: "vue",
    upColor: "#FFFFFF",
    overColor: "#0eea50",
    downColor: "#cae9af",
    active: false,
  },
  usiljs92: {
    hover: "VERMILION",
    url: "",
    target: "vue",
    upColor: "#FFFFFF",
    overColor: "#0eea50",
    downColor: "#cae9af",
    active: false,
  },
  usiljs93: {
    hover: "WABASH",
    url: "",
    target: "vue",
    upColor: "#3eb2b2",
    overColor: "#0eea50",
    downColor: "#cae9af",
    active: true,
    name: "Wabash",
    slug: "second-judicial-circuit",
  },
  usiljs94: {
    hover: "WARREN",
    url: "",
    target: "vue",
    upColor: "#3eb2b2",
    overColor: "#0eea50",
    downColor: "#cae9af",
    active: true,
    name: "Warren",
    slug: "ninth-judicial-circuit",
  },
  usiljs95: {
    hover: "WASHINGTON",
    url: "",
    target: "vue",
    upColor: "#3eb2b2",
    overColor: "#0eea50",
    downColor: "#cae9af",
    active: true,
    name: "Washington",
    slug: "washington-perry-counties",
  },
  usiljs96: {
    hover: "WAYNE",
    url: "",
    target: "vue",
    upColor: "#3eb2b2",
    overColor: "#0eea50",
    downColor: "#cae9af",
    active: true,
    name: "Wayne",
    slug: "second-judicial-circuit",
  },
  usiljs97: {
    hover: "WHITE",
    url: "",
    target: "vue",
    upColor: "#3eb2b2",
    overColor: "#0eea50",
    downColor: "#cae9af",
    active: true,
    name: "White",
    slug: "second-judicial-circuit",
  },
  usiljs98: {
    hover: "WHITESIDE",
    url: "",
    target: "vue",
    upColor: "#FFFFFF",
    overColor: "#0eea50",
    downColor: "#cae9af",
    active: false,
  },
  usiljs99: {
    hover: "WILL",
    url: "",
    target: "vue",
    upColor: "#3eb2b2",
    overColor: "#0eea50",
    downColor: "#cae9af",
    active: true,
    name: "Will",
    slug: "will-county",
  },
  usiljs100: {
    hover: "WILLIAMSON",
    url: "",
    target: "vue",
    upColor: "#FFFFFF",
    overColor: "#0eea50",
    downColor: "#cae9af",
    active: false,
  },
  usiljs101: {
    hover: "WINNEBAGO",
    url: "",
    target: "vue",
    upColor: "#3eb2b2",
    overColor: "#0eea50",
    downColor: "#cae9af",
    active: true,
    name: "Winnebago",
    slug: "winnebago-county",
  },
  usiljs102: {
    hover: "WOODFORD",
    url: "",
    target: "vue",
    upColor: "#FFFFFF",
    overColor: "#0eea50",
    downColor: "#cae9af",
    active: false,
  },
  general: {
    borderColor: "#9CA8B6",
    visibleNames: "#000000",
  },
};

export { usiljsconfig };
